<app-student-module ModuleName='Behavior Interventions' [NewHidden]="false" (New)="createBhvrIntv(content);" [PrintOptions]="printOptions">
  <sortable-table [data]="bhvrintvs" [headers]="headers"
                  [showDelete]="true" (delCall)="del($event)"
                  [showEdit]="true" (editCall)="editBhvrIntv($event, content)"
                  defaultSort="date"></sortable-table>
</app-student-module>


<ng-template #content let-modal>
  <form #form="ngForm" (submit)="save(modalBhvr, form)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" *ngIf="!modalBhvr.id">Add Behavior Intervention</h4>
      <h4 class="modal-title" id="modal-basic-title" *ngIf="modalBhvr.id">Edit Behavior Intervention</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="date" class="required-field">Date</label>
        <input type="date" class="form-control" id="date" name="date" [(ngModel)]="modalBhvr.date" required
               #date="ngModel" [max]="maxdate">
        <ng-container *ngIf="date.touched && date.errors">
          <span *ngIf="date.errors['required']" class="text-danger">You must provide a date for the behavior intervention</span>
          <span *ngIf="date.errors['max']" class="text-danger">You cannot provide a date in the future</span>
        </ng-container>
      </div>
      <div class="form-group">
        <label for="behavior" class="required-field">Behavior</label>
        <textarea required #behavior="ngModel" class="form-control" minlength="10" maxlength="2500" id="behavior"
                  name="behavior" [(ngModel)]="modalBhvr.behavior" rows="5" cols="20"></textarea>
        <div class="d-flex">
          <span class="ms-auto me-3 text-secondary">{{ modalBhvr.behavior?.length || 0 }} / 2500</span>
        </div>
        <ng-container *ngIf="behavior.touched && behavior.errors">
          <span *ngIf="behavior.errors['required']" class="text-danger">You must provide data for the behavior</span>
          <span *ngIf="behavior.errors['minlength']" class="text-danger">Data must be at least 10 characters</span>
          <span *ngIf="behavior.errors['maxlength']" class="text-danger">Data must be less than 2500 characters</span>
        </ng-container>
      </div>
      <div class="form-group">
        <label for="intervention" class="required-field">Intervention</label>
        <textarea required #intervention="ngModel" class="form-control" minlength="10" maxlength="2500"
                  id="intervention" name="intervention" [(ngModel)]="modalBhvr.intervention" rows="5"
                  cols="20"></textarea>
        <div class="d-flex">
          <span class="ms-auto me-3 text-secondary">{{ modalBhvr.intervention?.length || 0 }} / 2500</span>
        </div>
        <ng-container *ngIf="intervention.touched && intervention.errors">
          <span *ngIf="intervention.errors['required']" class="text-danger">You must provide an intervention.</span>
          <span *ngIf="intervention.errors['minlength']" class="text-danger">Intervention data must be at least 10 characters</span>
          <span *ngIf="intervention.errors['maxlength']" class="text-danger">Intervention data must be less than 2500 characters</span>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <div class="form-check me-auto" *ngIf="!modalBhvr.id">
      <input type="checkbox" class="form-check-input" id="add_more" [(ngModel)]="keepModalOpen">
      <label class="form-check-label" for="add_more">Add another behavior intervention</label>
    </div>
    <button class="btn btn-success" type="button" (click)="save(modalBhvr, form)"
            [disabled]="form.untouched || form.invalid">
      <span class="fa fa-save" aria-hidden="true">&nbsp;</span> Save
    </button>
    <button class="btn btn-warning" aria-label="Cancel" (click)="modal.dismiss('cancel')">
      Cancel
    </button>
  </div>
</ng-template>
